// extracted by mini-css-extract-plugin
export default {"page":"ClientMergeWizard_page__YMWs8","content":"ClientMergeWizard_content__m0DlT","footer":"ClientMergeWizard_footer__Hz5+8","footerInner":"ClientMergeWizard_footerInner__gYyXU"};